angular.module('natura').directive('pggMeasure', [ function() {
  return {
    restrict : "E",
    templateUrl : "assets/terkep/app/measure/measure.html",
    replace : true,
    scope : {
      map : "="
    },
    controller : "PggMeasureController",
    controllerAs : "ctrl",
    bindToController : true
  };
} ]);

angular.module('natura').controller(
    'PggMeasureController',
    [
        '$scope',
        '$compile',
        '$sce',
        'ngeoDecorateInteraction',
        'pggInteractionsProvider',
        function($scope, $compile, $sce, ngeoDecorateInteraction, pggInteractionsProvider) {
          $scope.map = this.map;

          this.lang = 'hu';
          this.measureStartMsg = null;
          this.measureLengthContinueMsg = null;
          this.measureAreaContinueMsg = null;
          this.measureAzimutContinueMsg = null;

          $scope.tooltips = {
            measureLength : $sce.trustAsHtml('Hossz<br />mérése'),
            measureArea : $sce.trustAsHtml('Terület<br />mérése'),
            measureAzimuth : $sce.trustAsHtml('Szög<br />mérése')
          };

          // Translations for the measure tools' tooltips.
          var measureStartMsgs = {
            'en' : $sce.trustAsHtml('Click to start drawing.'),
            'hu' : $sce.trustAsHtml('Kattintson a mérés megkezdéséhez')
          };
          var measureLengthContinueMsgs = {
            'en' : $sce.trustAsHtml('Click to continue drawing.<br>' + 'Double-click or click last point to finish.'),
            'hu' : $sce.trustAsHtml('Kattintson a mérés folytatásához.<br>'
                + 'Duplán kattintson az utolsó mérési pont lehelyezéséhez.')
          };
          var measureAreaContinueMsgs = {
            'en' : $sce.trustAsHtml('Click to continue drawing.<br>'
                + 'Double-click or click starting point to finish.'),
            'hu' : $sce.trustAsHtml('Kattintson a mérés folytatásához<br>'
                + 'Duplán kattintson az utolsó mérési pont lehelyezéséhez.')
          };
          var measureAzimutContinueMsgs = {
            'en' : $sce.trustAsHtml('Click to finish.'),
            'hu' : $sce.trustAsHtml('Kattintson a befejezéshez')
          };

          // Create elements for the measure tools' tooltips.
          var measureStartMsg = angular.element('<span ng-bind-html="ctrl.measureStartMsg"></span>');
          measureStartMsg = $compile(measureStartMsg)($scope);
          var measureLengthContinueMsg = angular.element('<span ng-bind-html="ctrl.measureLengthContinueMsg"></span>');
          measureLengthContinueMsg = $compile(measureLengthContinueMsg)($scope);
          var measureAreaContinueMsg = angular.element('<span ng-bind-html="ctrl.measureAreaContinueMsg"></span>');
          measureAreaContinueMsg = $compile(measureAreaContinueMsg)($scope);
          var measureAzimutContinueMsg = angular.element('<span ng-bind-html="ctrl.measureAzimutContinueMsg"></span>');
          measureAzimutContinueMsg = $compile(measureAzimutContinueMsg)($scope);

          // Watch the "lang" property and update the toolip messages
          // based on the selected language.
          $scope.$watch(angular.bind(this, function() {
            return this.lang;
          }), angular.bind(this, function(newVal) {
            this.measureStartMsg = measureStartMsgs[newVal];
            this.measureLengthContinueMsg = measureLengthContinueMsgs[newVal];
            this.measureAreaContinueMsg = measureAreaContinueMsgs[newVal];
            this.measureAzimutContinueMsg = measureAzimutContinueMsgs[newVal];
          }));

          var style = new ol.style.Style({
            fill : new ol.style.Fill({
              color : 'rgba(255, 255, 255, 0.4)'
            }),
            stroke : new ol.style.Stroke({
              color : 'rgba(0, 0, 0, 0.7)',
              lineDash : [ 10, 10 ],
              width : 2
            }),
            image : new ol.style.Circle({
              radius : 5,
              stroke : new ol.style.Stroke({
                color : 'rgba(0, 0, 0, 0.7)'
              }),
              fill : new ol.style.Fill({
                color : 'rgba(255, 255, 255, 0.2)'
              })
            })
          });

          var map = this.map;

          this.measureLength = new ngeo.interaction.MeasureLength({
            sketchStyle : style,
            startMsg : measureStartMsg[0],
            continueMsg : measureLengthContinueMsg[0]
          });

          var measureLength = this.measureLength;
          measureLength.setActive(false);
          ngeoDecorateInteraction(measureLength);
          map.addInteraction(measureLength);
          pggInteractionsProvider.addInteraction(measureLength);

          this.measureArea = new ngeo.interaction.MeasureArea({
            sketchStyle : style,
            startMsg : measureStartMsg[0],
            continueMsg : measureAreaContinueMsg[0]
          });

          var measureArea = this.measureArea;
          measureArea.setActive(false);
          ngeoDecorateInteraction(measureArea);
          map.addInteraction(measureArea);
          pggInteractionsProvider.addInteraction(measureArea);

          this.measureAzimut = new ngeo.interaction.MeasureAzimut({
            sketchStyle : style,
            startMsg : measureStartMsg[0],
            continueMsg : measureAzimutContinueMsg[0]
          });

          var measureAzimut = this.measureAzimut;
          measureAzimut.setActive(false);
          ngeoDecorateInteraction(measureAzimut);
          map.addInteraction(measureAzimut);
          pggInteractionsProvider.addInteraction(measureAzimut);

          // the following code shows how one can add additional information
          // to the
          // tooltip. This can be useful to display the elevation offset from
          // the
          // 2 points of an azimut measurement.
          // measureAzimut.on('measureend', function(evt) {
          // var el = evt.target.getTooltipElement();
          // el.innerHTML += '<br>Additional info';
          // });

          this.toggleMeasureLength = function() {
            if (measureLength.getActive()) {
              pggInteractionsProvider.activateInteraction(measureLength);
            } else {
              pggInteractionsProvider.deactivateInteraction(measureLength);
            }
          };

          this.toggleMeasureArea = function() {
            if (measureArea.getActive()) {
              pggInteractionsProvider.activateInteraction(measureArea);
            } else {
              pggInteractionsProvider.deactivateInteraction(measureArea);
            }
          };

          this.toggleMeasureAzimut = function() {
            if (measureAzimut.getActive()) {
              pggInteractionsProvider.activateInteraction(measureAzimut);
            } else {
              pggInteractionsProvider.deactivateInteraction(measureAzimut);
            }
          };

        } ]);
